import axios from 'axios'

export const getPurchaseReturns = (params) => {
  return axios.get('/finance/purchaseReturns', { params })
}

export const getTotalPurchaseReturns = (params) => {
  return axios.get('/finance/purchaseReturns/totals', { params })
}

export const addPurchaseReturn = (data) => {
  return axios.post('/finance/purchaseReturns', data)
}

export const editPurchaseReturn = (data) => {
  return axios.put(`/finance/purchaseReturns/${data.id}`, data)
}

export const deleteOnAddPurchaseReturnAttachment = (url) => {
  return axios.delete('/finance/purchaseReturns/attachments', { data: { url } })
}

export const deleteOnEditPurchaseReturnAttachment = (id, url) => {
  return axios.delete(`/finance/purchaseReturns/${id}/attachments`, { data: { url } })
}

export const getPurchaseReturn = (id, params) => {
  return axios.get(`/finance/purchaseReturns/${id}`, { params })
}

export const deletePurchaseReturn = (id) => {
  return axios.delete(`/finance/purchaseReturns/${id}`)
}

export const getPurchaseReturnLog = ({ id, params } = {}) => {
  return axios.get(`/finance/purchaseReturns/${id}/logs`, { params })
}

export const approvePurchaseReturn = (id) => {
  return axios.post(`/finance/purchaseReturns/${id}/approve`)
}

export const rejectPurchaseReturn = ({ id, data }) => {
  return axios.post(`/finance/purchaseReturns/${id}/reject`, data)
}

export const revertApprovalPurchaseReturn = (id) => {
  return axios.post(`/finance/purchaseReturns/${id}/revert`)
}

export const inputMassDeletePurchaseReturn = (data) => {
  return axios.post('/finance/purchaseReturns/inputMassDelete', data)
}

export const executeMassDeletePurchaseReturn = (data) => {
  return axios.delete('/finance/purchaseReturns/executeMassDelete', { data })
}
